module.exports = __webpack_public_path__ + "img/zengzhi_banner.2ba81531.png";